import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { isBrowser } from 'ws-scripts/modules/environment';

const TOPIC_KEY = 'ws-vehicle-location/update-store';

const publishStoreChange = (store) => {
	const pubsub = isBrowser && window?.DDC?.pubsub;
	if (pubsub) {
		return pubsub?.publish(TOPIC_KEY, store);
	}
	return null;
};

export const useLocation = (locationDefault) => {
	const locationObj = useSelector((state) => state.location);
	const [location, setLocation] = useState({
		id: locationObj?.accountId,
		name: locationObj?.name || locationDefault
	});

	useEffect(() => {
		const subscriber = window?.DDC?.pubsub?.subscribe(
			TOPIC_KEY,
			(newLocation) => setLocation(newLocation)
		);

		return () => {
			subscriber?.unsubscribe();
		};
	}, []);

	return { publishStoreChange, location };
};
